import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import "./fonts/Poppins-Bold/Poppins-Bold.ttf";
import "./fonts/Poppins-Regular/Poppins-Regular.ttf";
import "./fonts/Poppins-Semi-Bold/Poppins-SemiBold.ttf";
import "./fonts/Poppins-Italic/Poppins-Italic.ttf";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
